import { createFileRoute } from '@tanstack/react-router';

import { OpenChatButton, Wordmark } from '@/components/chrome';

export const Route = createFileRoute('/')({
  component: LandingPage,
});

// The chat host root is never linked from WhatsApp (tickets arrive as /t/<token>
// deep links). Someone reaching / directly gets a gentle pointer back to the
// message — there is nothing to authenticate or browse here.
function LandingPage() {
  return (
    <main className="app">
      <div className="topbar">
        <Wordmark />
      </div>
      <div className="state">
        <div className="serif" style={{ fontSize: 54, letterSpacing: '-1px' }}>
          WeeBee<span style={{ color: 'var(--accent)' }}>.</span>
        </div>
        <h3>
          Your tickets live
          <br />
          in your chat
        </h3>
        <p className="sub">
          There's nothing to show here directly. Tap the <b>Pay</b> or <b>Ticket</b> link WeeBee
          sent you in chat and it'll open right on this screen.
        </p>
      </div>
      <OpenChatButton />
    </main>
  );
}
